import {
    Icon,
    Link as MuiLink, Stack,
} from '@mui/material'

import { forwardRef } from 'react'

import Styles from './style'

export const Link = forwardRef((props, ref) => {
    const variant = props.variant || 'primary'

    return (
        <Stack direction={'row'} alignItems={'center'} ref={ref}>
            <MuiLink {...props} underline={'none'} className={(props.disabled) ? 'Mui-disabled' : ''}>
                {props.children}
            </MuiLink>
            {!props.noIcon && (<>&nbsp;<Icon sx={{fontSize: '16px', color: Styles.iconColor[variant], opacity: (props.disabled) ? 0.5 : 1}}>{Styles.icons[(props.external) ? 'external' : 'internal']}</Icon></>)}
        </Stack>
    )
})

Link.displayName = 'Link'

export default Link